export default __webpack_public_path__ + "static/media/aritra.2116e07c.png";